import { css, styled } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { PRESETS } from '../../AuthModal.presets';

export const StyledStepHeader = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: ${utils.rem(theme.Spacing.Size.MediumLarge)};
    gap: ${utils.rem(theme.Spacing.Size.Small)};
  `;
});

export const StyledBackButton = styled.button(({ theme }) => {
  return css`
    all: unset;
    background-color: transparent;
    width: fit-content;
    height: fit-content;
    padding: unset;
    margin: unset;
    position: relative;
    cursor: pointer;
    user-select: none;

    & svg {
      position: absolute;
      top: ${PRESETS.backIconTopOffset};
      left: 0;
    }
  `;
});
